import communicationHistoryList from './communicationHistoryList';

const list = communicationHistoryList('mms');

export const actions = list.actions;

export default list.reducer;